import { GalleryCarousel } from '@portally/ui';
import React, { useMemo, useState } from 'react';

import HiddenImagePreview from '@/components/HiddenImagePreview';
import RateLeaseAgreement from '@/components/RateLeaseAgreement';
import { translateUrl } from '@/components/UploadFile/util';
import { GetLeaseAgreementViewQuery } from '@/generated/graphql';

type LeaseAgreement = GetLeaseAgreementViewQuery['leaseAgreement'];

interface Props {
  id: string;
  name: string;
  myStatus: string;
  images: LeaseAgreement['images'];
  mobileImages: LeaseAgreement['mobileImages'];
  compressedImages: LeaseAgreement['compressedImages'];
  isAgreementOwner: boolean;
}

export default function ImageSection({
  images,
  mobileImages,
  compressedImages,
  name,
  myStatus,
  id,
  isAgreementOwner,
}: Props): React.ReactElement {
  const [selectedPreviewImage, setSelectedPreviewImage] = useState({
    visible: false,
    previewImage: '',
  });

  const galleryImages = useMemo(
    () =>
      images.map(image => ({
        id: image.id,
        url: image.url,
        mobileUrl: mobileImages.find(({ id }) => id === image.id)?.url,
        thumbnailUrl: compressedImages.find(({ id }) => id === image.id)?.url,
      })),
    [images, mobileImages, compressedImages],
  );
  const previewUrls = images.map(file => translateUrl(file.url));

  return (
    <div className={'relative h-full'}>
      {!isAgreementOwner && (
        <RateLeaseAgreement
          leaseAgreementView
          selectedLeaseAgreement={{ id, myStatus }}
        />
      )}

      <GalleryCarousel
        images={galleryImages}
        alt={name}
        className={'w-full'}
        onImageClick={index =>
          setSelectedPreviewImage({
            visible: true,
            previewImage: previewUrls[index],
          })
        }
      />

      <HiddenImagePreview
        imageUrls={previewUrls}
        visible={selectedPreviewImage.visible}
        selectedImage={selectedPreviewImage.previewImage}
        onVisibleChange={() =>
          setSelectedPreviewImage(prev => ({ ...prev, visible: false }))
        }
      />
    </div>
  );
}
